import { useState, useMemo } from 'react'
import PropTypes from 'prop-types'
import { loadStripe } from '@stripe/stripe-js'
import { Elements } from '@stripe/react-stripe-js'

import HolidayTipsPaymentElement from './HolidayTipsPaymentElement'
import { MIN_TIP_AMOUNT, MAX_TIP_AMOUNT, FIVE_TIP, TIP_MULTIPLIER } from './helpers'

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY)

const HolidayTipsPayment = ({ member, setMember = () => {} }) => {
  const [tip, setTip] = useState(FIVE_TIP)

  const totalAmount =
    Math.min(Math.max(Number(tip) || MIN_TIP_AMOUNT, MIN_TIP_AMOUNT), MAX_TIP_AMOUNT) *
    TIP_MULTIPLIER
  const options = useMemo(
    () => ({ mode: 'payment', amount: totalAmount, currency: 'usd' }),
    [totalAmount],
  )

  return (
    <Elements stripe={stripePromise} options={options}>
      <HolidayTipsPaymentElement
        tip={tip}
        totalAmount={totalAmount}
        member={member}
        setTip={setTip}
        setMember={setMember}
      />
    </Elements>
  )
}

HolidayTipsPayment.propTypes = {
  member: PropTypes.object.isRequired,
  setMember: PropTypes.func.isRequired,
}

export default HolidayTipsPayment
